<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconDoubleChevronDown_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="m12.797 17.726 4.675-4.675a.934.934 0 1 0-1.322-1.322l-4.014 4.014-4.014-4.014A.934.934 0 1 0 6.8 13.05l4.675 4.675a.934.934 0 0 0 1.322 0Zm.156-5.454 4.676-4.675a.934.934 0 1 0-1.323-1.322l-4.014 4.014-4.014-4.014a.934.934 0 1 0-1.322 1.322l4.675 4.675a.934.934 0 0 0 1.322 0Z"
        clip-rule="evenodd"
    />
</svg>
